<template>
  <div class="mainContainer">
    <div ref="publications">
      <div v-if="viewState === 'loading'">
        <v-col cols="12">
          <v-skeleton-loader
            v-bind="attrs"
            type="card-avatar, article"
          ></v-skeleton-loader>
        </v-col>
      </div>
      <div class="publications-wrapper" v-if="viewState === 'publications'">
        <div>
          <publication-list
            v-for="(subscribe, index) in publicationData"
            :key="`${subscribe.key}-${index}`"
            :source="subscribe"
            :isSingle="true"
            :index="index"
          />
        </div>
      </div>
    </div>
    <div v-if="viewState === 'no-publications'" class="emptyPosts">
      <img :src="require('@/assets/img/noPosts.png')" class="emptyContentImg"/>
    </div>
  </div>
</template>

<script>
import Publication from '@/components/publication/index'
// import { mapGetters } from 'vuex'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'singlePost',
  data () {
    return {
      attrs: {
        class: 'mb-6',
        boilerplate: true,
        elevation: 2
      },
      noPostSize: screen.width,
      startFirstLoad: false
    }
  },

  computed: {
    ...mapGetters(['getSinglePostData', 'getSinglePostRef']),
    loading () {
      return !this.startFirstLoad
    },
    hasContent () {
      return this.getSinglePostData && this.getSinglePostRef
    },
    publicationData () {
      return this.hasContent ? [{...this.getSinglePostData, ...this.getSinglePostRef}] : []
    },
    viewState () {
      let viewState = false
      if (!viewState && this.loading) viewState = 'loading'
      if (!viewState && this.hasContent) viewState = 'publications'
      if (!viewState && !this.hasContent) viewState = 'no-publications'
      return viewState
    }
  },
  components: { 'publication-list': Publication },
  methods: {
    ...mapActions({
      loadSinglePost: 'LOAD_SINGLE_POST',
      resetSinglePost: 'RESET_SINGLE_POST_ACTION'
    }),
    loadFinished () {
      this.startFirstLoad = true
    }
  },
  mounted () {
    this.loadSinglePost(this.$route.params.postId).then(this.loadFinished)
  },
  beforeDestroy () {
    this.resetSinglePost()
  }
}
</script>
<style lang="scss"></style>



// WEBPACK FOOTER //
// src/views/singlePost.vue